// removed by extract-text-webpack-plugin
module.exports = {"Container":"Main__Container__ZkDk0","LeftContainer":"Main__LeftContainer__17IDz","RightContainer":"Main__RightContainer__1MjW6","MenuContainer":"Main__MenuContainer__26n0D","MainContainer":"Main__MainContainer__1LWM_","Name":"Main__Name__198Ib","MenuImage":"Main__MenuImage__1dwRr","DrawerImage":"Main__DrawerImage__3pK3D"};


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Main/Main.css
// module id = 6148
// module chunks = 0